import type { ClaimClientUpdateConfiguration } from '@shared/constants/business/claim';
import { addBusinessDays, differenceInBusinessDays, differenceInCalendarDays } from '@shared/utils';
import type { Decimal } from 'decimal.js';
import { DateTime } from 'luxon';

export function getIncreasingAdjustment(excessAmount: Decimal) {
    return excessAmount.div(11);
}

export function getClaimClientUpdateDueSoonDate(configuration: ClaimClientUpdateConfiguration) {
    const today = DateTime.now().endOf('day').toJSDate();

    return configuration.dayIntervalType === 'BUSINESS'
        ? addBusinessDays(today, configuration.dueSoonDays)
        : DateTime.fromJSDate(today).plus({ days: configuration.dueSoonDays }).toJSDate();
}

export function calculateClaimClientUpdateDifferenceInDays({
    dueDate,
    overdueDate: overdueDateParam,
    dayIntervalType,
}: {
    dueDate: Date;
    overdueDate?: Date;
} & Pick<ClaimClientUpdateConfiguration, 'dayIntervalType'>) {
    const overdueDate = overdueDateParam || DateTime.now().endOf('day').toJSDate();

    return dayIntervalType === 'BUSINESS'
        ? differenceInBusinessDays(dueDate, overdueDate)
        : differenceInCalendarDays(dueDate, overdueDate);
}
